<script lang="ts">
    import type {DateFilterableDatatype, GenericDatatypedFilterDefinition} from '../../types';
    import DatatypeValueEditor from './DatatypeValueEditor.svelte';
    import FilterButton from './FilterButton.svelte';

    export let valueFilterDefinition: GenericDatatypedFilterDefinition<DateFilterableDatatype>;
</script>

<DatatypeValueEditor filterableDatatypeDefinition={valueFilterDefinition}>
    <svelte:fragment slot="filterButtons" let:value let:filterableDatatypeDefinition>
        <FilterButton {filterableDatatypeDefinition} {value} icon="less-than-equal" filterOperator="eqOrLess">
            Starší než
        </FilterButton>

        <FilterButton {filterableDatatypeDefinition} {value} icon="greater-than-equal" filterOperator="eqOrMore">
            Novější než
        </FilterButton>

        <FilterButton {filterableDatatypeDefinition} {value} icon="filter" defaultFilter>
            Rovno
        </FilterButton>
    </svelte:fragment>
</DatatypeValueEditor>